import { FC, useContext, useState } from 'react'
import { useLoadAudioFileFromUrl } from './hooks/useLoadAudioFileFromUrl'
import { AppContext } from '../AppContext'
import './UploadFormUrl.scss'

export const UploadFormUrl: FC = () => {
  const { setUploadOpened } = useContext(AppContext)
  const loadAudioFileFromUrl = useLoadAudioFileFromUrl()
  const [url, setUrl] = useState('')
  const [loading, setLoading] = useState(false)

  return (
    <form
      className="UploadFormUrl"
      onSubmit={(event) => {
        event.preventDefault()

        setLoading(true)

        loadAudioFileFromUrl(url)
          .then(() => setUploadOpened(false))
          .finally(() => setLoading(false))
      }}
    >
      <label className="label" htmlFor="upload-form-url-input">
        Open from URL
      </label>

      <input
        className="input"
        id="upload-form-url-input"
        type="text"
        placeholder="https://www..."
        onChange={(event) => setUrl(event.target.value)}
      />

      <button className="button" type="submit" disabled={loading}>
        {loading ? 'Loading...' : 'Open'}
      </button>
    </form>
  )
}
